import React, { useEffect, useState } from 'react'
import Input from 'components/Input'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import HeaderComponent from 'components/HeaderComponent'
import { destructureErrorMessage, filterValues } from 'Helper'
import { useDispatch } from 'react-redux'
import { InfoValidation } from 'pages/Settings/validation'
import { apiRequest } from 'store/Misc/apiRequest'
import { withTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { setFormLoading } from 'store/slices/miscSlice'
import useSWR from 'swr'
import LogoUploader from './LogoUploader'
export default withTranslation()(function Info({ t, info }) {
  const { data: Categories } = useSWR('collections/categories?page=1&page-size=100')
  const [categories, setCategories] = useState(null)
  const [defaultCategory, setDefaultCategory] = useState({})
  const [edit, setEdit] = useState(false)
  const dispatch = useDispatch()
  const method = useForm({
    mode: 'all',
    resolver: yupResolver(InfoValidation),
  })
  const { reset, getValues, watch } = method
  useEffect(() => {
    if (Categories?.data) setCategories(Categories.data)
  }, [Categories])
  useEffect(() => {
    setDefaultCategory({ value: JSON.parse(info?.category).id, label: JSON.parse(info?.category).name })
  }, [info])
  useEffect(() => {
    // reset(info)
    reset({
      description: info?.about,
      name: info?.name,
      website: info?.website,
      category_id: JSON.parse(info?.category).id,
      avatar: info?.avatar
    })
  }, [info, reset])
  const fields = [
    [
      {
        name: 'name',
        label: t('registration.field.bname'),
        placeholder: t('registration.field.bname'),
        disabled: true
      },
      {
        name: 'category_id',
        label: t('settings.business_info.category_id'),
        defaultValue: defaultCategory,
        options: filterValues({ options: categories ?? [], param: { label: 'name', value: 'id' } }),
        disabled: !edit
      },
    ],
    {
      name: 'description',
      label: t('settings.business_info.description.label'),
      placeholder: t('settings.business_info.description.placeholder'),
      multiline: true,
      disabled: !edit
    },
    {
      name: 'website',
      label: t('settings.business_info.website.label'),
      placeholder: t('settings.business_info.website.placeholder'),
      disabled: !edit
    }
  ]
  const { handleSubmit } = method
  const submit = async (payload) => {
    const formdata = new FormData();
    if (edit) {
      console.log(payload)
      for (const key in payload) {
          const element = payload[key];
          formdata.append(key, element)
        }
      // formdata.append('avatar', getValues().avatar)
      dispatch(setFormLoading())
      try {
        await apiRequest({
          method: 'post',
          payload: formdata,
          url: 'settings/business-info'
        })
        toast.success('Business information updated successfully')
      } catch ({ message }) {
        console.log(message)
        
        // destructureErrorMessage(message).map(msg => {
        //   if ((msg).toString().includes('avatar')) {
        //     return toast.error((msg).toString().replace('avatar', 'business logo'), { autoClose: 15000 })
        //   }
        //   return toast.error(msg, { autoClose: 15000 })
        // })
      } finally {
        setEdit(false)
      }
      dispatch(setFormLoading('close'))
    } else {
      setEdit(true)
    }
  }
  return (
    <FormProvider {...method}>
      <form className="w-full mb-5 bg-white py-8 px-4 md:px-12 rounded-xl shadow-sm" onSubmit={handleSubmit(submit)}>
        <HeaderComponent
          title="Business Information" btnText={edit ? 'Save' : 'Edit'} btnClick={() => submit(watch())}
          cancelBtn={edit ? { text: 'Cancel', click: () => { setEdit(false) } } : false} />
        <div className="w-full grid md:grid-cols-2 md:gap-5 gap-y-7 mb-5">
          {
            fields.map((field, index) => {
              return (
                <React.Fragment key={`${index}_`}>
                  {
                    field.length ? (
                      <>
                        {
                          field.map(singleField => {
                            return (
                              <Input
                                name={singleField.name}
                                label={singleField.label}
                                placeholder={singleField.placeholder}
                                options={singleField?.options}
                                classList="w-full rounded-md"
                                variant="outlined"
                                key={singleField.name}
                                defaultValue={singleField?.defaultValue}
                                disabled={singleField?.disabled}
                              />
                            )
                          })
                        }
                      </>
                    ) : (
                      <Input
                        name={field.name}
                        label={field.label}
                        multiline={field?.multiline ?? false}
                        minRows={field?.multiline ? 3 : 1}
                        placeholder={field?.placeholder}
                        variant="outlined"
                        disabled={field?.disabled}
                      />
                    )
                  }
                </React.Fragment>
              )
            })
          }
        </div>
      </form>
      <LogoUploader info={info} name={'avatar'}  title={t('settings.business_logo.title')} defaultPic={info?.merchant_avatar} id={'logo'}/>
      <LogoUploader info={info} name={'background_image'} title={'Upload Background Image'}  defaultPic={info?.background_image} id={'background_image'} />
    </FormProvider>
  )
})